import { useWatch } from "@web-monorepo/hooks";
import { isTesting } from "@web-monorepo/environment";
import { useFetchedIsFeatureSwitchOn } from "../index";
import type { FeatureSwitchName } from "../generated";

interface Props {
  switchName: FeatureSwitchName;
  bodyClassName: string;
}

/**
 * Component to conditionally add a class to the body based on a feature switch.
 *
 * @link https://www.notion.so/classdojo/CSS-Reset-for-Headers-Feature-Switched-2b25ed942e8a80aa88b3cbdce23668fb
 */
export function BodyClassFeatureSwitch({ switchName, bodyClassName }: Props) {
  const isSwitchEnabled = useFetchedIsFeatureSwitchOn(switchName) || isTesting;

  useWatch(
    [isSwitchEnabled],
    () => {
      document.body.classList.toggle(bodyClassName, isSwitchEnabled);
    },
    { immediate: true },
  );

  return null;
}
